import Swal from 'sweetalert2'



// WEBPACK FOOTER //
// ./resources/js/plugins/sweetalert2.js